














































































































import Vue from 'vue';
import Button from '../components/common/Button/Button.vue';
import Input from '../components/common/Input/Input.vue';
import CheckBox from '../components/common/CheckBox/CheckBox.vue';
import NotificationText from '../components/common/NotificationText/NotificationText.vue';
import axios from 'axios';

export default Vue.extend({
  components: {
    Button,
    Input,
    CheckBox,
    NotificationText,
  },
  data(): {
    errors: {
      email?: string;
      password?: string;
      passwordMatch?: string;
      name?: string;
      termsOfCondition?: string;
    };
    email: string;
    password: string;
    passwordConfirm: string;
    lastName: string;
    firstName: string;
    organization: string;
    termsOfCondition: boolean;
  } {
    return {
      errors: {},
      email: '',
      password: '',
      passwordConfirm: '',
      lastName: '',
      firstName: '',
      organization: '',
      termsOfCondition: false,
    };
  },
  methods: {
    onClickSignUpCancelButton() {
      this.$router.go(-1);
    },
    validateSignUpInfo(): void {
      let newErrorObject: {
        email?: string;
        password?: string;
        passwordMatch?: string;
        name?: string;
        termsOfCondition?: string;
      } = new Object();
      //email Check
      const emailRegex =
        /^([\w]*)([a-zA-Z0-9]+)([\w]*)([a-zA-Z0-9]+)([\w]+)@(([a-zA-Z0-9]+\.)+)[a-zA-Z0-9]{2,8}$/g;
      if ((emailRegex.exec(this.email) as RegExpExecArray) === null) {
        newErrorObject['email'] = '이메일이 주어진 조건과 맞지 않습니다.';
      }

      //password check
      const passwordRegex = /^[0-9a-zA-z]{8,}/g;
      if (this.password.length === 0) {
        newErrorObject['password'] = '비밀번호 칸이 비어 있습니다.';
      } else if (passwordRegex.exec(this.password) === null) {
        newErrorObject['password'] = '비밀번호가 주어진 조건과 맞지 않습니다.';
      } else {
        if (this.password !== this.passwordConfirm) {
          newErrorObject['passwordMatch'] = '비밀번호가 동일하지 않습니다.';
        }
      }

      if (this.passwordConfirm.length === 0) {
        newErrorObject['passwordMatch'] = '비밀번호 확인 칸이 비어 있습니다.';
      }

      //name check
      if (this.lastName.length === 0 || this.firstName.length === 0) {
        newErrorObject['name'] = '성 또는 이름 칸이 비어 있습니다.';
      }

      //terms-of-condition
      if (this.termsOfCondition === false) {
        newErrorObject['termsOfCondition'] =
          '해당 서비스의 이용을 위해서는 동의가 필요합니다.';
      }

      if (Object.keys(newErrorObject).length > 0) {
        this.errors = newErrorObject;
        return;
      }

      axios
        .post('/userapi/v1/users', {
          user_email: this.email,
          user_password: this.password,
          user_name: this.lastName + this.firstName,
        })
        .then((result) => {
          if (result.status === 201) {
            this.$router.push('/login');
          } else {
            new Error('bad result status');
          }
          this.errors = newErrorObject;
        })
        .catch((error) => {
          if (error.response) {
            // Request made and server responded
            if (error.response.status === 403) {
              newErrorObject['email'] =
                '이미 가입된 이메일입니다. 다른 이메일을 사용해주세요.';
            } else {
              alert('잠시 후에 다시 시도해주세요.');
            }
          } else if (error.request) {
            // Request made but no response was received
            alert('잠시 후에 다시 시도해주세요.');
          } else {
            // Somethiing happened in setting up the request that triggered an error
            alert('에러가 발생했습니다.');
          }
          this.errors = newErrorObject;
        });
    },
  },
});
